import Forms4i from '../../common/forms/forms25.js';
import FetchHelpers from '../../common/helpers/fetchhelpers.js';
import StatusMessages from '../../common/helpers/statusmessage.js';
import BusyButton from '../../common/helpers/busybutton.js';
import Recaptcha from '../../common/forms/recaptcha.js';

const unsubscribeForm = new Forms4i();
const recaptcha = new Recaptcha();
const unsubscribeFormDiv = document.getElementById("unsubscribeForm");
const accountCode = document.getElementById("AccountCode");
const zipCode = document.getElementById("ZipCode");
const userName = document.getElementById("Name");
const resultHeading = document.getElementById("resultHeading");
const resultInfo = document.getElementById("resultInfo");
const result = document.getElementById("result");
const btnSubmit = document.getElementById("btnSubmit");

async function init(){
    unsubscribeForm.init({
        form: unsubscribeFormDiv,
        submitButton: btnSubmit,
        //recaptcha: true,
        onSuccess: submitUnsubscribeForm,
        onFailure: showError
    });

    // Clear all fields in case user goes back to form after submitting
    unsubscribeForm.clearFormFields();
    accountCode.addEventListener("keyup", userTyping);
}

function userTyping(e){
    if (e.target.value.length > 0 && e.target.value.charAt(0).toUpperCase() == "C" && nameGroup.classList.contains("hide")){ 
        // User is a customer, show name field and hide the other fields
        showArea(nameGroup);
        userName.classList.add("required");
        userName.setAttribute("aria-required", "true");
    }else if(e.target.value.length == 0 && !nameGroup.classList.contains("hide")){
        // User is not a customer, hide name field and show the other fields
        hideArea(nameGroup);
        userName.classList.remove("required");
        userName.setAttribute("aria-required", "false");
    }
}

async function submitUnsubscribeForm(){
    //BusyButton.show(btnSubmit);
    // Check if grecaptcha is defined
    // if not, try to fetch the script again 
    recaptcha.ready(async () => {
        BusyButton.show(btnSubmit);
        const token = await recaptcha.getToken();
        const unsubscribeData = {
            accountCode : accountCode.value,
            zipCode : zipCode.value,
            userName : userName.value,
            recaptchaToken : token
        };
        
        try{
            const response = await fetch('/unsubscribe/submit', {
                method: 'POST', 
                body: JSON.stringify(unsubscribeData), 
                headers: { 
                    'Content-Type': 'application/json', 
                    'X-Requested-With': 'fetch', 
                    "RequestVerificationToken": FetchHelpers.headerToken 
                }
            });
            //if(!response.ok) throw new Error(`Error processing request: ${response.statusText}`);
            const responseJSON = await response.json();
            await showResult(responseJSON);
        }catch(error){
            console.error(error);
            showError();
        }
    });
}

function hideArea(field){
    field.classList.add("hide");
    field.hidden = true;
}

function showArea(field){
    field.classList.remove("hide");
    field.hidden = false;
}

async function showResult(responseJSON) {
    BusyButton.clear();
    resultHeading.innerHTML = `<h2>${responseJSON.heading}</h2>`;
    resultInfo.innerHTML = responseJSON.info;

    hideArea(unsubscribeFormDiv);
    showArea(resultHeading);
    showArea(result);
}

function showError() {
    BusyButton.clear();
    unsubscribeForm.clearFormFields();
    StatusMessages.showError(btnSubmit, "We were unable to unsubscribe you from 4imprint catalogs and mailings. Please try again later or call us toll free at 1-877-520-2006.");
}

init();